export default __webpack_public_path__ + "static/media/katinka-profile1.765a8e1d.png";